import { memo } from 'react';
import ChatPanel from '../../shared-components/chatPanel/ChatPanel';

function RightSideLayout1(props) {
  return (
    <>
      <ChatPanel />
    </>
  );
}

export default memo(RightSideLayout1);
